<div class="tnved">
  <div class="tnved__inner">
    <h1>{{ titleText }}</h1>

    <div class="tnved__tabs" role="tablist">
      <button type="button" class="tnved__tab" role="tab" [class.tnved__tab--active]="activeTab === 'categories'"
              [attr.aria-selected]="activeTab === 'categories'" (click)="activeTab = 'categories'">{{ tabCategoriesText }}</button>
      <button type="button" class="tnved__tab" role="tab" [class.tnved__tab--active]="activeTab === 'code'"
              [attr.aria-selected]="activeTab === 'code'" (click)="activeTab = 'code'">{{ tabCodeText }}</button>
    </div>

    <ng-template #resultsTable let-rows>
      <div class="tnved__table-wrap">
        <table class="tnved__table">
          <thead>
            <tr>
              <th>{{ columnCodeText }}</th>
              <th>{{ columnLevelText }}</th>
              <th>{{ columnNameText }}</th>
              <th class="tnved__num">{{ columnSimilarityText }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of rows; let i = index" [class.tnved__row--top]="i === 0">
              <td class="tnved__code">{{ r.code }}</td>
              <td><span class="tnved__level" [class.tnved__level--chapter]="r.level === 2">{{ levelText(r.level) }}</span></td>
              <td>{{ r.name }}</td>
              <td class="tnved__num">{{ r.similarity | number:'1.4-4' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>

    <!-- Вкладка: поиск категорий -->
    <section *ngIf="activeTab === 'categories'">
      <p class="tnved__subtitle">{{ subtitleText }}</p>

      <form class="tnved__form" (ngSubmit)="onSearch()">
        <input
          class="tnved__input"
          type="text"
          name="query"
          [(ngModel)]="query"
          [placeholder]="placeholderText"
          autocomplete="off"
        />
        <button class="tnved__button" type="submit" [disabled]="loading || !query.trim()">
          {{ loading ? searchingText : searchText }}
        </button>
      </form>

      <p class="tnved__error" *ngIf="error">{{ errorText }}</p>
      <p class="tnved__empty" *ngIf="searched && !error && results.length === 0">{{ emptyText }}</p>

      <ng-container *ngIf="results.length > 0">
        <ng-container *ngTemplateOutlet="resultsTable; context: { $implicit: results }"></ng-container>
      </ng-container>
    </section>

    <!-- Вкладка: поиск кода ТН ВЭД -->
    <section *ngIf="activeTab === 'code'">
      <p class="tnved__subtitle">{{ subtitleCodeText }}</p>

      <form class="tnved__form tnved__form--stack" (ngSubmit)="onResolve()">
        <label class="tnved__field">
          <span class="tnved__label">{{ nameLabelText }}</span>
          <input class="tnved__input" type="text" name="productName" [(ngModel)]="productName"
                 [placeholder]="placeholderText" autocomplete="off" />
        </label>
        <label class="tnved__field">
          <span class="tnved__label">{{ descriptionLabelText }}</span>
          <input class="tnved__input" type="text" name="productDescription" [(ngModel)]="productDescription"
                 [placeholder]="descriptionPlaceholderText" autocomplete="off" />
        </label>
        <label class="tnved__check" *ngIf="cacheUiEnabled">
          <input type="checkbox" name="refresh" [(ngModel)]="refresh" />
          <span>{{ refreshText }}</span>
        </label>
        <button class="tnved__button" type="submit" [disabled]="resolving || !productName.trim()">
          {{ resolving ? resolvingText : resolveText }}
        </button>
      </form>

      <p class="tnved__error" *ngIf="resolveError">{{ errorText }}</p>

      <div class="tnved__result" *ngIf="resolveResult as res">
        <p class="tnved__empty" *ngIf="!res.code">{{ notFoundText }}</p>

        <ng-container *ngIf="res.code">
          <div class="tnved__result-label">{{ resultCodeText }}</div>
          <div class="tnved__result-code">{{ res.code }}</div>
          <div class="tnved__result-name" *ngIf="res.codeName">{{ res.codeName }}</div>
          <p class="tnved__warn" *ngIf="!res.full">{{ notFullText }}</p>

          <div class="tnved__result-meta" *ngIf="res.productDescription">
            <span class="tnved__result-label">{{ resultProductText }}:</span> {{ res.productDescription }}
          </div>
          <div class="tnved__result-meta">
            <span class="tnved__level" [class.tnved__level--chapter]="res.source === 'AI'">{{ sourceText(res.source) }}</span>
            <span class="tnved__level tnved__level--cached" *ngIf="cacheUiEnabled && res.cached">{{ cachedText }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="res.hints?.length">
          <h2 class="tnved__hints-title">{{ hintsTitleText }}</h2>
          <ng-container *ngTemplateOutlet="resultsTable; context: { $implicit: res.hints }"></ng-container>
        </ng-container>
      </div>
    </section>
  </div>
</div>
